import fetch from '../../utils/fetch'

export function bindPlate(params) {
    return fetch({
        url: '/api/platenumberUser/wxBindPlatenumber',
        method: 'POST',
        data: params
    })
}

export function relievePlate(params) {
    return fetch({
        url: '/api/platenumberUser/wxRelievePlate',
        method: 'POST',
        data: params
    })
}

export function plateList(params) {
    return fetch({
        url: '/api/platenumberUser/userPlatenumberList',
        method: 'GET',
        params
    })
}
